import { page } from "@inertiajs/svelte"
import { derived } from "svelte/store"

const auth = derived(page, ($page) => $page.props.auth)

export default auth
// Account
export const merchant = derived(auth, ($auth) => $auth.merchant)
// User
export const designer = derived(auth, ($auth) => $auth.designer)
